// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimProcessingStatusDto
 */
export interface IClaimProcessingStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimProcessingStatusDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimProcessingStatusDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimProcessingStatusDto
     */
    claim_processing_status_type?: IClaimProcessingStatusDtoClaimProcessingStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimProcessingStatusDto
     */
    claim_processing_substatus_type?: IClaimProcessingStatusDtoClaimProcessingSubstatusTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IClaimProcessingStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimProcessingStatusDto
     */
    valid_to?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IClaimProcessingStatusDtoClaimProcessingStatusTypeEnum {
    SUBMITTED = 'SUBMITTED',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    PROCESSING = 'PROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAID = 'REPAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    AUTHORIZED = 'AUTHORIZED',
    DECLINED = 'DECLINED',
    EXPIRED = 'EXPIRED',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DEDUCTIBLE_TRACKING = 'DEDUCTIBLE_TRACKING',
    ACTION_REQUIRED = 'ACTION_REQUIRED',
    STOP_PROCESSING = 'STOP_PROCESSING',
    VOIDED = 'VOIDED',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimProcessingStatusDtoClaimProcessingSubstatusTypeEnum {
    DOCS_NEEDED = 'DOCS_NEEDED',
    CARRIER_CLAIM = 'CARRIER_CLAIM',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PAYMENT_REJECTED = 'PAYMENT_REJECTED',
    REPAYMENT_REJECTED = 'REPAYMENT_REJECTED',
    PARTIAL_REPAYMENT = 'PARTIAL_REPAYMENT',
    FULL_REPAYMENT = 'FULL_REPAYMENT',
    PARTIAL_PAYMENT = 'PARTIAL_PAYMENT'
}


/**
 * Check if a given object implements the IClaimProcessingStatusDto interface.
 */
export function instanceOfIClaimProcessingStatusDto(value: object): value is IClaimProcessingStatusDto {
    return true;
}

export function IClaimProcessingStatusDtoFromJSON(json: any): IClaimProcessingStatusDto {
    return IClaimProcessingStatusDtoFromJSONTyped(json, false);
}

export function IClaimProcessingStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimProcessingStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'claim_processing_status_type': json['claim_processing_status_type'] == null ? undefined : json['claim_processing_status_type'],
        'claim_processing_substatus_type': json['claim_processing_substatus_type'] == null ? undefined : json['claim_processing_substatus_type'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IClaimProcessingStatusDtoToJSON(json: any): IClaimProcessingStatusDto {
    return IClaimProcessingStatusDtoToJSONTyped(json, false);
}

export function IClaimProcessingStatusDtoToJSONTyped(value?: IClaimProcessingStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claim_id': value['claim_id'],
        'claim_processing_status_type': value['claim_processing_status_type'],
        'claim_processing_substatus_type': value['claim_processing_substatus_type'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
    };
}

